import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { ShellComponent } from './layout/shell/shell.component';
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { VerifyEmailComponent } from './auth/verify-email/verify-email.component';
import { HrDashboardComponent } from './hr-dashboard/hr-dashboard.component';
import { EmployeesComponent } from './employees/employees.component';
import { AttendanceComponent } from './Attendance/attendance.component';
import { LeaveManagementComponent } from './leave-management/leave-management.component';
import { PayrollComponent } from './payroll/payroll.component';
import { DepartmentsComponent } from './departments/departments.component';
import { PerformanceComponent } from './performance/performance.component';
import { ReportsComponent } from './reports/reports.component';
import { SettingsComponent } from './settings/settings.component';
import { ProjectsComponent } from './features/projects/projects.component';
import { ProjectDetailComponent } from './features/projects/project-detail/project-detail.component';
import { ProjectFormComponent } from './features/projects/project-form/project-form.component';
import { IssuesComponent } from './features/issues/issues.component';
import { IssueDetailComponent } from './features/issues/issue-detail/issue-detail.component';
import { EpicsComponent } from './features/epics/epics.component';
import { ScrumComponent } from './features/scrum/scrum.component';
import { KanbanComponent } from './features/kanban/kanban.component';
import { BugsComponent } from './features/bugs/bugs.component';
import { BugsDetailComponent } from './features/bugs/bugs-detail/bugs-detail.component';
import { QaComponent } from './features/qa/qa.component';
import { QaDetailComponent } from './features/qa/qa-detail/qa-detail.component';
import { TimeTrackingComponent } from './features/time-tracking/time-tracking.component';
import { HrComponent } from './features/hr/hr.component';
import { RecruitmentComponent } from './features/recruitment/recruitment.component';
import { FinanceComponent } from './features/finance/finance.component';
import { AssetsComponent } from './features/assets/assets.component';
import { ChatComponent } from './features/chat/chat.component';
import { MeetingsComponent } from './features/meetings/meetings.component';
import { CalendarComponent } from './features/calendar/calendar.component';
import { FilesComponent } from './features/files/files.component';
import { KnowledgeComponent } from './features/knowledge/knowledge.component';
import { OrganizationsComponent } from './features/organizations/organizations.component';
import { UsersComponent } from './features/users/users.component';
import { IssueWorkflowsComponent } from './features/issue-workflows/issue-workflows.component';
import { PmAdvancedComponent } from './features/pm-advanced/pm-advanced.component';
import { SharedRoadmapComponent } from './features/pm-advanced/shared-roadmap.component';
import { PmReportsComponent } from './features/pm-reports/pm-reports.component';
import { AiAssistantComponent } from './features/ai-assistant/ai-assistant.component';
import { NotificationsComponent } from './features/notifications/notifications.component';
import { IntegrationsComponent } from './features/integrations/integrations.component';
import { AdminComponent } from './features/admin/admin.component';
import { AutomationComponent } from './features/automation/automation.component';
import { PmApprovalsComponent } from './features/pm-approvals/pm-approvals.component';
import { PmAiComponent } from './features/pm-ai/pm-ai.component';
import { MyWorkComponent } from './features/my-work/my-work.component';
import { AccountsComponent } from './features/accounts/accounts.component';
import { TeamLeadDashboardComponent } from './features/team-lead/team-lead-dashboard.component';
import { ProjectTasksComponent } from './features/project-tasks/project-tasks.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'verify-email', component: VerifyEmailComponent },
  { path: 'roadmap/shared/:token', component: SharedRoadmapComponent },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: HrDashboardComponent },
      { path: 'my-work', component: MyWorkComponent },
      { path: 'accounts', component: AccountsComponent },
      { path: 'team-lead', component: TeamLeadDashboardComponent },
      { path: 'change-password', component: ChangePasswordComponent },
      { path: 'projects', component: ProjectsComponent },
      { path: 'projects/new', component: ProjectFormComponent },
      { path: 'projects/:id', component: ProjectDetailComponent },
      { path: 'projects/:id/edit', component: ProjectFormComponent },
      { path: 'tasks', component: ProjectTasksComponent },
      { path: 'issues', component: IssuesComponent },
      { path: 'issues/:id', component: IssueDetailComponent },
      { path: 'epics', component: EpicsComponent },
      { path: 'scrum', component: ScrumComponent },
      { path: 'kanban', component: KanbanComponent },
      { path: 'bugs', component: BugsComponent },
      { path: 'bugs/:id', component: BugsDetailComponent },
      { path: 'qa', component: QaComponent },
      { path: 'qa/:id', component: QaDetailComponent },
      { path: 'time-tracking', component: TimeTrackingComponent },
      { path: 'employees/new', component: EmployeesComponent },
      { path: 'employees', component: EmployeesComponent },
      { path: 'hr', component: HrComponent },
      { path: 'attendance', component: AttendanceComponent },
      { path: 'leave', component: LeaveManagementComponent },
      { path: 'leave-management', redirectTo: 'leave', pathMatch: 'full' },
      { path: 'recruitment', component: RecruitmentComponent },
      { path: 'performance', component: PerformanceComponent },
      { path: 'departments', component: DepartmentsComponent },
      { path: 'payroll', component: PayrollComponent },
      { path: 'finance', component: FinanceComponent },
      { path: 'assets', component: AssetsComponent },
      { path: 'chat', component: ChatComponent },
      { path: 'meetings', component: MeetingsComponent },
      { path: 'calendar', component: CalendarComponent },
      { path: 'files', component: FilesComponent },
      { path: 'knowledge', component: KnowledgeComponent },
      { path: 'organizations', component: OrganizationsComponent },
      { path: 'users', component: UsersComponent },
      { path: 'workflows', component: IssueWorkflowsComponent },
      { path: 'pm-approvals', component: PmApprovalsComponent },
      { path: 'automation', component: AutomationComponent },
      { path: 'pm-ai', component: PmAiComponent },
      { path: 'pm-advanced', component: PmAdvancedComponent },
      { path: 'pm-reports', component: PmReportsComponent },
      { path: 'ai-assistant', component: AiAssistantComponent },
      { path: 'notifications', component: NotificationsComponent },
      { path: 'reports', component: ReportsComponent },
      { path: 'integrations', component: IntegrationsComponent },
      { path: 'admin', component: AdminComponent, canActivate: [roleGuard], data: { roles: ['super_admin', 'tenant_admin'] } },
      { path: 'settings', component: SettingsComponent }
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];
